import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { PersonaNaturalComponent } from '../PersonaNatural/persona-natural.component';
import { Fur } from 'src/app/models/Fur';
import { Persona } from 'src/app/models/Persona';
import { Denunciante } from 'src/app/models/Denunciante';
import { DatosEmpresaDenuncComponent } from '../datos-empresa-denunc/datos-empresa-denunc.component';

@Component({
  selector: 'app-agrupacion',
  templateUrl: './agrupacion.component.html',
  styleUrls: ['./agrupacion.component.css']
})
export class AgrupacionComponent implements OnInit {

  @ViewChild(PersonaNaturalComponent) personaNaturalComponent: PersonaNaturalComponent;
  flgLectura = false;
  nombreAgrupacion: string ;
  flgRepreLegal = false;

  @Output() datosComplAgrupOut = new EventEmitter();
  @Output() cambioTipoDocOut = new EventEmitter();


  @ViewChild(DatosEmpresaDenuncComponent) datosEmpresaDenuncC: DatosEmpresaDenuncComponent;
  /*
  formAgrupacion = new FormGroup({
    input_nom_agrup : new FormControl('')
  });
  */
  constructor() { }

  ngOnInit() {

    this.datosEmpresaDenuncC.setMostrarEmprNoReg(true);
    this.datosEmpresaDenuncC.setEtiquetasAgrupacion();


  }

  _cambioTipoDocOut() {

    this.cambioTipoDocOut.emit();

  }

  _datosComplementOut(personaOut: Persona) {

    this.datosComplAgrupOut.emit(personaOut);

  }

  _cambioRepreLegal(flgEvent) {

    this.flgRepreLegal = flgEvent.checked;

  }


  agrupacionCReadEnable() {
    this.flgLectura = true;
    this.personaNaturalComponent.personaNaturalCReadEnable();
    this.datosEmpresaDenuncC.setModoLectura(true);
  }

  agrupacionCReadDisable() {
    this.flgLectura = false;
    this.personaNaturalComponent.personaNaturalCReadDisable();
    this.datosEmpresaDenuncC.setModoLectura(false);
  }

  setAgrupacionC(fur: Fur) {
    this.personaNaturalComponent.setPersonaNaturalC(fur.denunciante, 1);
    // this.nombreAgrupacion = fur.denunciante.cdenuncianteDscagrup;
    this.flgRepreLegal = fur.denunciante.cdenuncianteFlgreprelegal == 'SI' ? true : false;
    this.datosEmpresaDenuncC.setDatosEmpresa(fur.denunciante);
  }

  getDatosAgrupacion() {

    let vDenunciante: Denunciante =  new Denunciante();


    // vDenunciante.personaComplemento = this.datosEmpresaDenuncC.getDatosEmpresa().personaComplemento;
    vDenunciante = this.datosEmpresaDenuncC.getDatosEmpresa();
    vDenunciante.persona = this.personaNaturalComponent.getPersonaNaturalC();

    // vDenunciante.cdenuncianteDscrefdomccompl = vDenunciante.personaComplemento.cpersonaDscreferencia;

    return vDenunciante;

  }

  getFlgRepreLegal() {


    return this.flgRepreLegal;

  }

  setAtributosGenerales(numCaso: number) {

    switch (numCaso) {
      case 1:

        this.datosEmpresaDenuncC.setCambioAtributos(2);

        break;

      default:
        break;
    }

  }

  // setTimeout(()=> {

  //   this.personaNaturalComponent.formPersonaNatural.controls.select_tipDocumento.setValue("1");;
  //   this.personaNaturalComponent.cambiarTipDocumento("1");
  //   this.personaNaturalComponent.formPersonaNatural.controls.select_tipDocumento.disable();

  // }, 2);


}
